<template>
	<IconButtonLayout class="thumbs-up-button">
		<template #default="{ iconClass }">
			<FontAwesomeIcon
				:class="iconClass"
				:icon="[ `fal`, `thumbs-up`]"
			/>
		</template>
	</IconButtonLayout>
</template>

<script>
import IconButtonLayout from "./IconButtonLayout.vue";

export default {
	name: "ThumbsUpButton",
	components: {
		IconButtonLayout,
	},
};
</script>

<style lang="scss" scoped></style>
